import SeriesCard from "@/components/feature/SeriesCard";
import { seriesList } from "@/mocks/series";

const steps = [
  { t: "导火索", d: "从第一张图、第一条动态开始" },
  { t: "发酵", d: "实锤加码、声明回应、粉丝站队" },
  { t: "定性", d: "通报落地或和解收官，走向见分晓" },
];

export default function SeriesSection() {
  return (
    <section id="series" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-container px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">系列事件时间线</span>
            <h2 className="mt-2 text-2xl text-foreground-950 md:text-3xl">一个系列，是怎样一步步走到定论的</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              不追单一热搜，把同一系列事件的每个节点按日期串联，相似剧情和后续走向一次摸清。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="overflow-hidden rounded-3xl bg-primary-600 p-6 text-background-50 lg:col-span-1">
            <span className="inline-flex items-center gap-1 rounded-full bg-background-50/15 px-3 py-1 text-xs">
              <i className="ri-timeline-view text-secondary-300"></i> 如何看懂一条时间线
            </span>
            <ol className="mt-5 space-y-5">
              {steps.map((s, i) => (
                <li key={s.t} className="relative flex gap-3">
                  <div className="flex flex-col items-center">
                    <span className="font-display flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-primary-700">
                      {i + 1}
                    </span>
                    {i < steps.length - 1 && <span className="mt-1 w-px flex-1 bg-background-50/30"></span>}
                  </div>
                  <div className="pb-4">
                    <h3 className="text-sm font-semibold text-background-50">{s.t}</h3>
                    <p className="mt-1 text-xs leading-5 text-background-200/90">{s.d}</p>
                  </div>
                </li>
              ))}
            </ol>
            <p className="mt-4 rounded-xl bg-background-50/10 p-3 text-xs leading-5 text-background-100/90">
              我们只做信息梳理，把判断权交还给你——冷静吃瓜，先看清再站队。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2">
            {seriesList.map((s) => (
              <SeriesCard key={s.slug} series={s} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}